import * as React from 'react';
import { getContinueWithoutLoginUrl } from 'ts/config/ConfigService';
import { getWindow } from 'ts/window/Window';
import { handleIFrameLoginError } from '../../../services/iframe-login/IFrameLoginErrorHandler';
import { LoginProps, WrappedLoginComponentProps } from '../../hoc/Login/interfaces';
import { withLogin } from '../../hoc/Login/withLogin';
import { IFrameLoginView } from './IFrameLoginView';
import { navigation } from '@origin-digital/reporting-client';

const IFrameLoginComponent: React.FC<WrappedLoginComponentProps> = ({
  disableUsernameIcon,
  checkingUser,
  error,
  loading,
  password,
  loginSubmit,
  handlePasswordOnChange,
  passwordError,
  handleUsernameOnChange,
  handleUsernameOnBlur,
  usernameError,
  username,
}) => {
  React.useEffect(() => {
    navigation('screen', {
      currentUri: 'https://www.originenergy.com.au/sign-up/login/',
      friendlyUri: 'originenergy:sign-up:login-modal',
    });
  }, []);

  return (
    <IFrameLoginView
      disableUsernameIcon={disableUsernameIcon}
      checkingUser={checkingUser}
      loading={loading}
      username={username}
      loginError={error}
      password={password}
      loginSubmit={loginSubmit}
      onPasswordChange={handlePasswordOnChange}
      passwordError={passwordError}
      handleUsernameOnChange={handleUsernameOnChange}
      handleUsernameOnBlur={handleUsernameOnBlur}
      usernameError={usernameError}
      onContinueWithoutLoginClick={continueWithoutLoginHandler}
    />
  );
};

const continueWithoutLoginHandler = () => {
  getWindow().location.assign(getContinueWithoutLoginUrl());
};

const IFrameLoginPageWithHoc = withLogin(IFrameLoginComponent);

const IFrameLoginPage: React.FC<LoginProps> = (props) => (
  <IFrameLoginPageWithHoc
    {...props}
    customPasswordErrorMessage="That password doesn't match your email address."
    customUsernameErrorMessage="Hmm, we don't have that email in our records."
    customErrorHandler={handleIFrameLoginError}
  />
);

export { IFrameLoginPage, IFrameLoginPageWithHoc };
